import { useQuery } from "@tanstack/react-query";

import { MUTATION_KEYS } from "@/constants/mutationKeys";
import { QUERY_KEYS } from "@/constants/queryKeys";
import useMutate, { TMutationConfig } from "@/hooks/useMutate";

import {
  createBilling,
  getBillingOnboardingData,
  getInstallationList,
} from "./MultiStepForm.services";

export const useCreateBilling = (props?: TMutationConfig) => useMutate({
  ...props,
  mutationKey: [MUTATION_KEYS.CREATE_BILLING],
  mutationFn: createBilling,
  config: {
    useSuccessMessage: false,
    errorMessage: props?.errorMessage,
  },
});

export const useGetBillingOnboardingData = () => useQuery({
  queryKey: [QUERY_KEYS.BILLING_ONBOARDING_DATA],
  queryFn: getBillingOnboardingData,
});

export const useGetInstallationList = () => useQuery({
  queryKey: [QUERY_KEYS.INSTALLATION_LIST],
  queryFn: getInstallationList,
});
